// extracted by mini-css-extract-plugin
export default {"mainContainer":"informed_mainContainer__-yPN2","informedContainer":"informed_informedContainer__AQWbt"};